import styled, { css } from 'styled-components';

export const StyledSubCardActivity = styled.div`
  --card-padding: 24px;

  display: grid;
  grid-template-columns: 376px 193px 383px 1fr;
  background-color: ${({ theme }) => theme.colors.white};
  padding-inline: var(--card-padding);
  border-radius: 4px;
  height: 113px;

  .date {
    width: 139px;
  }

  .participation-info {
    margin: 24px 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .h3-5 {
      color: ${({ theme }) => theme.colors.textSecondary};
    }
  }
`;

export const Col = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-block: var(--card-padding);

  &:not(:last-child) {
    border-right: 1px solid ${({ theme }) => theme.colors.primaryDarkGray400};
    padding-right: 40px;
    margin-right: 40px;
    white-space: nowrap;
  }
`;

const blackText = css`
  color: ${({ theme }) => theme.colors.black};
  font-size: 18px;
  font-weight: 600;
`;

export const ActivityNumber = styled.span`
  ${blackText}
  text-transform: uppercase;

  &::after {
    counter-increment: activity-n;
    content: 'Attività ' counter(activity-n);
  }
`;

export const ActivityCode = styled.span`
  color: ${({ theme }) => theme.colors.primaryDarkGray600};
  text-transform: uppercase;
  width: fit-content;
`;

export const ActivityTitle = styled.span`
  ${blackText}
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 241px;
`;
